var _path, _path2, _ellipse, _path3, _path4, _rect, _rect2, _rect3, _ellipse2, _rect4, _rect5, _rect6, _ellipse3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 112,
    viewBox: "0 0 139 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.9019 112C98.1738 112 123.525 86.9279 123.525 56C123.525 25.0721 98.1738 0 66.9019 0C35.6301 0 10.2793 25.0721 10.2793 56C10.2793 86.9279 35.6301 112 66.9019 112Z",
    fill: "#303030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.755 91.6973C116.271 91.5155 116.814 91.2738 117.233 90.9239C117.73 90.5083 117.932 89.9731 118.068 89.4097C118.243 88.6858 118.312 87.9148 118.524 87.1898C118.602 86.9205 118.753 86.8187 118.817 86.7736C118.981 86.6595 119.146 86.629 119.301 86.6404C119.485 86.6536 119.738 86.7225 119.905 87.0279C119.929 87.0716 119.959 87.1381 119.98 87.2294C119.995 87.2962 120.005 87.5053 120.021 87.5916C120.061 87.8039 120.095 88.0163 120.126 88.2298C120.231 88.9404 120.291 89.544 120.622 90.1968C121.07 91.0832 121.52 91.6255 122.13 91.8657C122.719 92.098 123.424 92.0543 124.325 91.8721C124.41 91.8516 124.495 91.834 124.579 91.8196C124.976 91.751 125.356 92.0088 125.434 92.4C125.512 92.791 125.259 93.172 124.866 93.2579C124.784 93.2758 124.703 93.2928 124.623 93.3084C123.406 93.6063 121.997 94.6698 121.178 95.601C120.926 95.8881 120.556 96.6909 120.179 97.2029C119.901 97.5807 119.588 97.8297 119.326 97.9177C119.15 97.9769 119.002 97.9679 118.879 97.9379C118.701 97.8945 118.554 97.7992 118.44 97.6476C118.379 97.5646 118.322 97.4534 118.294 97.3115C118.281 97.2431 118.28 97.0695 118.28 96.9909C118.203 96.7296 118.109 96.4744 118.041 96.2108C117.877 95.5816 117.557 95.1834 117.176 94.6572C116.82 94.1648 116.437 93.8553 115.876 93.6084C115.804 93.5908 115.215 93.4483 115.007 93.3664C114.703 93.2465 114.559 93.0456 114.506 92.9373C114.417 92.7537 114.408 92.5933 114.425 92.4596C114.452 92.2622 114.541 92.0933 114.7 91.9569C114.799 91.8721 114.946 91.7897 115.143 91.7495C115.295 91.7181 115.699 91.7 115.755 91.6973ZM119.208 90.672C119.236 90.7321 119.265 90.7925 119.296 90.8535C119.953 92.1516 120.688 92.8763 121.581 93.228L121.611 93.2394C121.013 93.6782 120.472 94.1686 120.059 94.6387C119.889 94.8323 119.663 95.2344 119.42 95.6468C119.199 94.9355 118.837 94.4328 118.382 93.8037C118.034 93.3236 117.67 92.9623 117.223 92.6678C117.57 92.4916 117.901 92.2851 118.19 92.044C118.67 91.6425 118.988 91.1773 119.208 90.672Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.68169,
    cy: 45.0873,
    rx: 2.68169,
    ry: 2.6522,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8699 21.3206C25.1741 18.9479 23.8038 17.0918 21.7037 15.7514C21.4561 15.5932 21.3835 15.2645 21.5436 15.018C21.7015 14.7715 22.0324 14.6998 22.28 14.8579C24.6042 16.3421 26.1239 18.3961 26.8944 21.0232C26.9776 21.3043 26.8132 21.5994 26.5315 21.6814C26.2476 21.7636 25.951 21.6018 25.8699 21.3206Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8484 18.1007C50.2625 18.5855 50.6339 19.1078 50.9498 19.6639C51.0906 19.9114 51.3382 20.4376 51.3766 20.8888C51.4193 21.3695 51.255 21.775 50.8324 21.9886C50.2711 22.2718 49.8228 22.2423 49.4771 22.071C49.1441 21.9064 48.8838 21.5831 48.7194 21.1495C48.4057 20.3208 48.4526 19.0543 48.617 18.3315C48.1752 17.878 47.6907 17.4667 47.172 17.1011C43.3089 14.3781 37.6422 15.3821 33.2818 19.4537C31.7558 20.8792 31.0216 23.873 30.6395 27.103C30.044 32.1324 30.3834 37.7496 30.4304 39.3953C30.441 39.8017 30.4026 40.0429 30.3813 40.0911C30.281 40.3281 30.1038 40.3896 29.98 40.413C29.8007 40.4448 29.6578 40.4109 29.5425 40.3514C29.3867 40.2699 29.2586 40.1263 29.1988 39.9049C29.1668 39.7826 29.1583 39.6123 29.1626 39.4308C29.1668 39.3049 29.1925 39.1673 29.1669 39.077C29.0004 38.4991 28.7997 37.9347 28.6034 37.3663C27.9482 35.4556 27.1008 33.6651 26.1596 31.8767C23.1694 26.1941 20.2774 20.1898 15.3748 15.8603C15.155 15.666 15.1336 15.3301 15.33 15.111C15.5242 14.8919 15.8615 14.8719 16.0834 15.0664C21.0842 19.4815 24.0551 25.5892 27.1051 31.3843C27.9055 32.9056 28.6397 34.4291 29.2501 36.0226C29.1882 33.2037 29.2117 29.3019 29.7303 25.8495C30.1913 22.7791 31.0685 20.0656 32.5519 18.6797C37.3285 14.2195 43.5586 13.2519 47.7888 16.235C48.2413 16.5544 48.6724 16.9056 49.0737 17.2865C51.287 13.3107 56.0252 11.7172 60.2127 13.6188C60.4817 13.7405 60.5991 14.0555 60.4774 14.322C60.3536 14.5885 60.0377 14.7061 59.7688 14.5844C55.9953 12.871 51.716 14.4001 49.8484 18.1007ZM49.539 19.4318C49.7119 19.6747 49.8719 19.9265 50.0213 20.1868C50.1003 20.3265 50.2369 20.5951 50.2945 20.858C50.3073 20.9195 50.3095 21.0159 50.3095 21.0605C50.1622 21.1327 50.047 21.1675 49.9531 21.1206C49.8357 21.0629 49.7759 20.927 49.7183 20.7752C49.5731 20.3943 49.5262 19.8893 49.539 19.4318Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.7695,
    y: 29.0542,
    width: 97.4728,
    height: 34.7513,
    rx: 17.3757,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 81.0039,
    y: 41.0176,
    width: 32.8687,
    height: 4.55755,
    rx: 2.27878,
    fill: "#1C1C1C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.2695,
    y: 47.854,
    width: 64.7697,
    height: 4.55755,
    rx: 2.27878,
    fill: "#FFB43A"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.774,
    cy: 46.7145,
    rx: 5.66702,
    ry: 5.69694,
    fill: "#E1DCEB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 58.1084,
    width: 97.4728,
    height: 34.7513,
    rx: 17.3757,
    fill: "#FFB43A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.3672,
    y: 70.0723,
    width: 32.8687,
    height: 4.55755,
    rx: 2.27878,
    fill: "#1C1C1C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.3672,
    y: 76.9087,
    width: 64.7697,
    height: 4.55755,
    rx: 2.27878,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.167,
    cy: 75.7692,
    rx: 5.66702,
    ry: 5.69694,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddItem);
export default __webpack_public_path__ + "static/media/add-item.86bdd1e8e02f72002d513d3e25f9b16b.svg";
export { ForwardRef as ReactComponent };